class CartUpsells extends HTMLElement {
  static SELECTORS = {
    carousel: '.sidecart_carousel',
    image: '.slick-slide:not(.slick-cloned) .product-item__image',
  };

  connectedCallback() {
    this.carousel = this.querySelector(CartUpsells.SELECTORS.carousel);
    this.handleSetPosition = this.setArrowHeight.bind(this);
    this.handleResize = this.setArrowHeight.bind(this);
    this.handleImageLoad = this.setArrowHeight.bind(this);
    this.initializeSlider();
  }

  disconnectedCallback() {
    this.destroySlider();
  }

  initializeSlider() {
    const desktop = Number(this.carousel.dataset.slidesDesktop);
    const mobile = Number(this.carousel.dataset.slidesMobile);

    const carouselOptions = {
      slidesToShow: (desktop ?? 3) + 0.2,
      slidesToScroll: Math.floor(desktop ?? 3),
      arrows: true,
      infinite: false,
      touchThreshold: 20,
      edgeFriction: 0.1,
      responsive: [{
        breakpoint: 992,
        settings: {
          slidesToShow: (mobile ?? 2) + 0.7,
          slidesToScroll: Math.floor(mobile ?? 2),
          arrows: false,
        },
      }],
    };

    $(this.carousel).slick(carouselOptions);
    $(this.carousel).on('setPosition', this.handleSetPosition);
    this.carousel.addEventListener('load', this.handleImageLoad, true);
    window.addEventListener('resize', this.handleResize);
    this.setArrowHeight();
    window.requestAnimationFrame(() => this.setArrowHeight());
  }

  destroySlider() {
    if (this.carousel) {
      $(this.carousel).off('setPosition', this.handleSetPosition);
      this.carousel.removeEventListener('load', this.handleImageLoad, true);
      window.removeEventListener('resize', this.handleResize);
      this.carousel.style.removeProperty('--sidecart_arrow_height');
    }

    if (this.carousel && $(this.carousel).hasClass('slick-initialized')) {
      $(this.carousel).slick('unslick');
    }
  }

  setArrowHeight() {
    if (!this.carousel) {
      return;
    }

    const image = this.carousel.querySelector(CartUpsells.SELECTORS.image);
    if (!image) {
      return;
    }

    const imageHeight = image.getBoundingClientRect().height;
    if (imageHeight <= 0) {
      return;
    }

    this.carousel.style.setProperty('--sidecart_arrow_height', `${Math.round(imageHeight)}px`);
  }
}

window.customElements.get('cart-upsells') ||
  window.customElements.define('cart-upsells', CartUpsells);
